import React, { useContext, useMemo, useState, useEffect } from "react";
import '../styles/FixedActionBar.css';
import { CartContext } from "../contexts/CartContext.js";
import { useNavigate } from "react-router-dom";

const FixedActionBar = ({ product, mode = 'white'}) => {
  const { addToCart, cartItems } = useContext(CartContext);
  const navigate = useNavigate();

  // 2) On récupère le prix "one_time"
  const priceOneTime = product?.price?.data?.find(
    (price) => price.type === "one_time"
  );
  const buyPrice = priceOneTime ? priceOneTime.unit_amount / 100 : 0;
  const InitBuyPrice = priceOneTime?.metadata?.init_price 
    ? parseFloat(priceOneTime?.metadata?.init_price.replace(',', '.')) 
    : null;

  /**
   * 3) IMPORTANT : on mémorise le tableau de tailles pour
   *    éviter l'avertissement ESLint et éviter que `sizes`
   *    ne change à chaque rendu si product ne change pas réellement.
   */
  const sizes = useMemo(() => {
    if (!product?.metadata?.size) {
      return [];
    }
    return product.metadata.size.split(";");
  }, [product]);

  // 4) On gère la taille sélectionnée dans un state local
  const [selectedSize, setSelectedSize] = useState("");

  /**
   * 5) Dès que `sizes` change, on définit la 1ère taille
   *    comme valeur par défaut.
   */
  useEffect(() => {
    if (sizes.length > 0) {
      setSelectedSize(sizes[0]);
    } else {
      setSelectedSize("");
    }
  }, [sizes]);

  /**
   * 6) Récupération du "priceItem" one_time
   *    (exemple transformProduct)
   */
  const transformProduct = (prod, type) =>  {
    if (!prod?.price?.data) {
      return prod;
    }
    const foundPrice = prod.price.data.find(
      (priceItem) => priceItem.type === type
    );
    if (!foundPrice) {
      return prod;
    }
    return {
      ...prod,
      price: foundPrice,
    };
  };

  /**
   * 7) Clic sur "Acheter" => on insère la taille choisie
   *    dans le metadata avant d'ajouter au panier
   */
  const handleBuy = () => {
    const productTransformed = transformProduct(product, "one_time");
    
    const newId =
      cartItems && cartItems.length > 0
        ? Math.max(...cartItems.map((item) => item.id)) + 1
        : 0;

    productTransformed.id = newId;  
    // Ajout de la taille choisie au metadata
    productTransformed.metadata = {
      ...productTransformed.metadata,
      selectedSize: selectedSize, 
    };

    addToCart(productTransformed);
    navigate('/checkout/cart');
  };

  return (
    <div className="fixed-action-bar">

      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        {/* Pastille de couleur */}
        <div 
          style={{
            width: 25,
            height: 25,
            backgroundColor: product.metadata.color,
            borderRadius: '50%',
            border: '3px solid lightGray',
            marginRight: 10
          }}
        ></div>

        {/* Sélecteur de taille s'il y a des tailles */}
        {sizes.length > 0 && (
          <select
            style={{ padding: "11px 15px", marginRight: 10, borderRadius: 28, minHeight: 30, minWidth: 70, fontSize: 16, color: "#4FB987" }}
            value={selectedSize}
            onChange={(e) => setSelectedSize(e.target.value)}
          >
            {sizes.map((size, idx) => (
              <option key={idx} value={size}>
                {size}
              </option>
            ))}
          </select>
        )}
      </div>

      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        {/* Prix barré + prix actuel */}
        <div style={{ marginRight: 10, display: 'flex', flexDirection: 'column' }}>
          {InitBuyPrice && (
            <small style={{ textDecorationLine: 'line-through' }}>
              {InitBuyPrice}&nbsp;€
            </small>
          )}
          <strong>{buyPrice.toFixed(2)}&nbsp;€</strong>
        </div>


        {/* Bouton Acheter */}
        <button 
          className="btn buy"
          style={{ 
            borderColor: "#fff", 
            color: "#fff", 
            backgroundColor: "#4FB897" 
          }}
          onClick={handleBuy}
          disabled={sizes.length > 0 && !selectedSize}
        >
          Ajouter au panier
        </button>
      </div>
    </div>
  );
};

export default FixedActionBar;
